import { useEffect } from 'react';
import { PRODUCTION_DOMAIN } from '@/lib/constants';

function upsertMeta(name: string, content: string, attr: 'name' | 'property' = 'name') {
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.content = content;
}

function upsertCanonical(href: string) {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = 'canonical';
    document.head.appendChild(el);
  }
  el.href = href;
}

export interface PageMetaOptions {
  title: string;
  description?: string;
  /** Path only, e.g. `/pricing` — canonical becomes PRODUCTION_DOMAIN + path */
  path?: string;
  ogImage?: string;
}

export function usePageMeta({ title, description, path = '', ogImage }: PageMetaOptions) {
  useEffect(() => {
    document.title = title;

    const canonical = `${PRODUCTION_DOMAIN}${path.startsWith('/') ? path : path ? `/${path}` : ''}`;
    upsertCanonical(canonical);

    if (description) {
      upsertMeta('description', description);
      upsertMeta('og:description', description, 'property');
    }

    upsertMeta('og:title', title, 'property');
    upsertMeta('og:url', canonical, 'property');

    const image = ogImage ?? `${PRODUCTION_DOMAIN}/marketing/analytics-dashboard.png`;
    upsertMeta('og:image', image, 'property');
  }, [title, description, path, ogImage]);
}
